import { requestPost } from 'utils/request';
import { handleErrors } from '@tcc/scarecrow';

const BASE_URL = '/api/user/external/v2';

export function sendVerificationEmailRequest(email) {
  return requestPost(`${BASE_URL}/sendVerificationEmail`, {
    data: JSON.stringify({email})
  }).then(handleErrors);
}

export function verifyEmailRequest(verificationToken) {
  return requestPost(`${BASE_URL}/verifyEmail`, {
    data: JSON.stringify({
      verificationToken
    })
  }).then(handleErrors);
}
